<div class="walkthrough-step-container">
  <!-- CONTENT -->
  <div class="content">
    <h1 class="content-title header-title">Item Summaries</h1>
    <p class="content-subtitle">Reporting never looked so sweet</p>

    <br />
    <br />
    <p class="content-description-title">Find me in the slide-out menu</p>
    <p class="content-description">
      Get an itemised breakdown of all your food and drink items for the day with just a few clicks! Easy Peasy (lemon
      squeezy?)
    </p>
  </div>

  <!-- ICON / BG -->
  <div class="background">
    <ion-img src="assets/images/walkthrough/summary.svg"></ion-img>
  </div>
</div>
